function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Immutable from 'seamless-immutable';
import * as actions from './actions';
var initialState = Immutable.from({
  loggedIn: false,
  bearerToken: null,
  apiKey: {
    clientId: null,
    clientSecret: null,
    grantType: 'client_credentials'
  },
  spid: {
    authorizationCode: null,
    clientSecret: null,
    clientId: null,
    grantType: 'spid_authorization_code',
    include: 'insecure_sessions'
  },
  loginError: {
    hasError: false,
    loginType: 'default'
  },
  loginAlert: {
    isOpen: false,
    redirectUrl: '',
    cancelUrl: '',
    message: '',
    tag: ''
  }
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actions.LOGOUT:
      return state.set('loggedIn', false);

    case actions.SET_LOGGED_IN:
      return state.set('loggedIn', payload);

    case actions.SET_BEARER_TOKEN:
      return state.set('bearerToken', payload);

    case actions.HAS_LOGIN_ERROR:
      return state.set('loginError', payload);

    case actions.SHOW_LOGIN_TO_CONTINUE:
    case actions.CLOSE_LOGIN_TO_CONTINUE:
      return state.set('loginAlert', payload);

    case actions.SET_API_KEY:
      return state.set('apiKey', _objectSpread(_objectSpread({}, state.apiKey), payload)).set('spid', _objectSpread(_objectSpread({}, state.spid), payload));

    case actions.SET_SPID_KEY:
      return state.set('spid', _objectSpread(_objectSpread({}, state.spid), payload));

    default:
      return state;
  }
});
//# sourceMappingURL=reducer.js.map